import enumeration from "./enumeration";

const UserLanguage = {
  en: "EN",
  es: "ES",
  pt: "PT",
  th: "TH",
  vi: "VI",
};

export default enumeration(UserLanguage);
